import { PosttestCard } from '@holmescorp/card';
import { RiseActivation } from '@holmescorp/rise-activation';
import { registry } from 'lcc-state';
import { register_base_lp_widgets } from '../../shared/init/lp-init';

export function register_lp_widgets(): void {
	register_base_lp_widgets();

	registry.define('RiseActivation', RiseActivation);

	// widgets for additional resources carousel
	registry.define('PosttestCard', PosttestCard);
}
